export default function TranslateTradierOption(optionSymbol) {
    //example symbol: AMZN210115C03250000
    let underlying;
    let optionDetails;
    let index=0;
    for(let i in optionSymbol) {
        let char=optionSymbol[i];
        if(!(!isNaN(parseFloat(char)) && isFinite(char))) { //ie is a character
            index++;
        } else {
            underlying = optionSymbol.substring(0, index);
            optionDetails=optionSymbol.substring(index);        
            break;
        }
    }
    let date;
    let strikeDetails;
    index=0;
    for(let i in optionDetails) {
        let char=optionDetails[i];
        if((!isNaN(parseFloat(char)) && isFinite(char))) { //ie is a character
            index++;
        } else {
            date = optionDetails.substring(0, index);
            strikeDetails=optionDetails.substring(index);        
            break;
        }
    }
    
    let monthDay=date.substring(2);
    let clearMonthDay=monthDay.substring(0,2)+"-"+monthDay.substring(2);    
   
    let callPut=strikeDetails[0];
    let strike=strikeDetails.substring(1);
    strike=strike.replace(/^0+/, ''); //get rid of leading zeroes
    //eliminateBad trailing zeroes
    let decimals=strike.substring(strike.length-3).replace(/0+$/, '');
    strike = strike.substring(0, strike.length-3) + (decimals.length>0? "."+decimals : "");
    return underlying+"."+clearMonthDay+"."+callPut+"."+strike;
}